module.exports = __webpack_public_path__ + "assets/img/icon-9.ab3ebd04.png";